import type { Table } from '@tanstack/react-table';
import { faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@repo/videa-components/src/index';
import { useSelector } from 'react-redux';

import { usePreferences } from '@/react-query/usePreferences';

import { exportTableToCsv } from '../helpers/exportTableToCsv';

type InsightsExportButtonProps<TData> = {
  table: Table<TData>;
  filename: string;
  isDisabled?: boolean;
};

/**
 * Export button for insights tables. Triggers CSV download of the current table (filtered/sorted).
 * Only rendered when the organization-level enableInsightsTableExport preference is enabled.
 * This preference is set at the org level and cannot be toggled by users in the UI.
 */
export const InsightsExportButton = <TData,>({
  table,
  filename,
  isDisabled = false,
}: InsightsExportButtonProps<TData>) => {
  const { data: prefs } = usePreferences();
  const displayPhi = useSelector((state: { login?: { user?: { privacyOn?: boolean } } }) => state.login?.user?.privacyOn ?? false);
  const isPrivacyOn = !displayPhi;
  if (!prefs?.enableInsightsTableExport) return null;

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={() => exportTableToCsv(table, filename, { isPrivacyOn })}
      disabled={isDisabled}
    >
      <FontAwesomeIcon icon={faDownload} className="vai-mr-2" />
      Export
    </Button>
  );
};
